import { isTTLDeviceConnected, pulseD0 } from "./webUsbFtdi";

/**
 * Fires a TTL pulse used to sync trial starts with external recording equipment.
 * Awaits the rising edge (D0 HIGH) transfer before capturing pulseTime, so the timestamp is
 * taken as close as possible to the instant D0 actually asserts - never grabbed before the
 * transfer is confirmed sent, and never delayed by any work after it. The falling edge (D0
 * LOW after `ms`) is fire-and-forget inside pulseD0 and does not block this call.
 * Only runs when the current mission's metadata enables it (pulseTTLtrialStart) and the device is connected
 * @param {boolean} pulseTTLtrialStart The mission metadata flag enabling the TTL pulse at trial start
 * @param {JsPsych} jsPsych jsPsych instance, used to timestamp the pulse against the same clock as time_elapsed
 * @returns {Promise<{fired: boolean, pulseTime: number|null}>} Whether a pulse was attempted (mirrors the
 *   pulseTTLtrialStart data field), and the elapsed experiment time captured immediately after
 *   D0 was confirmed asserted high - null when a study is TTL-enabled but not actually pulsing (disabled or disconnected)
 */
export async function pulseTTL(pulseTTLtrialStart, jsPsych) {
  if (!pulseTTLtrialStart || !isTTLDeviceConnected()) return { fired: false, pulseTime: null };

  try {
    await pulseD0(250);
  } catch (err) {
    console.error("[TTL] pulse failed:", err);
    return { fired: false, pulseTime: null };
  }

  const pulseTime = jsPsych.getTotalTime();
  console.log(`[TTL] D0 HIGH confirmed asserted, pulseTime captured at performance.now()=${performance.now().toFixed(2)}`);

  return { fired: true, pulseTime };
}
